import { Typography, Stack, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import icon from '../../Assets/NoResults.png';

export default function EmptyList() {
  const { t } = useTranslation('global');
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{ height: 'calc(100vh - 470px)', px: 1 }}
    >
      <Box
        component="img"
        src={icon}
        sx={{
          maxWidth: { xs: '72px' },
          maxHeight: { xs: '72px' },
        }}
      />
      <Stack gap={1} alignItems="center">
        <Typography variant="h6">
          {t('globalSearch.emptyList.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('globalSearch.emptyList.subtitle')}
        </Typography>
      </Stack>
    </Stack>
  );
}
